import { render, staticRenderFns } from "./AssignedStudents.vue?vue&type=template&id=60d13d23&scoped=true"
import script from "./AssignedStudents.vue?vue&type=script&lang=js"
export * from "./AssignedStudents.vue?vue&type=script&lang=js"
import style0 from "./AssignedStudents.vue?vue&type=style&index=0&id=60d13d23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d13d23",
  null
  
)

export default component.exports